module.exports = __webpack_public_path__ + "img/book10.e4a77f18.jpg";